import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmLearnMoreCarouselClick = ({ model, trim, gtmBodyStyle, availabilityFlag, action, productName }) => {
    const gtmPayload = {
        event: 'learn_more_arrows',
        action,
        product_name: productName,
        model,
        trim,
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmLearnMoreCarouselClick;
